import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { posts } from '../../data/posts';
import { SectionHeading } from '../ui/SectionHeading';
export function BlogSection() {
  const {
    t,
    b,
    lang
  } = useLanguage();
  const formatter = new Intl.DateTimeFormat(lang === 'es' ? 'es-US' : 'en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return <section id="blog" className="scroll-mt-24 bg-mist py-20 md:py-24" aria-labelledby="blog-title" data-id="element-170" data-mp="sqc94tv528tw">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8" data-id="element-171" data-mp="nr91d1nrxoi8">
        <SectionHeading id="blog-title" title={t('blog.title')} subtitle={t('blog.sub')} data-id="element-172" data-mp="npeh7pkbu0f7" />

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-173" data-mp="irmoitbuya9y">
          {posts.map(post => <article key={post.slug} className="group flex h-full flex-col overflow-hidden rounded-lg bg-white transition-shadow duration-200 ease-smooth hover:shadow-lg" data-id="element-174" data-mp="38i9nvpl1n27b">
              <img src={post.image} alt={b(post.title)} loading="lazy" className="aspect-[3/2] w-full object-cover" width={600} height={400} data-id="element-175" data-mp="1gvp46i3m2pxl" />
              <div className="flex flex-1 flex-col p-6" data-id="element-176" data-mp="1bvb53pjzmqbp">
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-700" data-id="element-177" data-mp="1bxxdtsim7bvi">
                  {b(post.category)}
                  <span className="h-1 w-1 rounded-full bg-navy/20" aria-hidden="true" data-id="element-178" data-mp="11yoojcyp2lfh" />
                  <span className="font-semibold normal-case tracking-normal text-ink-muted" data-id="element-179" data-mp="o71f0bfqrger">
                    {formatter.format(new Date(post.date))}
                  </span>
                </p>
                <h3 className="mt-3 font-display text-lg font-bold leading-snug text-navy" data-id="element-180" data-mp="e7kee8fcjspn">{b(post.title)}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-181" data-mp="j63y026gwseu">{b(post.excerpt)}</p>
                <Link to={`/services/${post.serviceSlug}`} className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold text-brand-700 hover:text-brand-800" data-id="element-182" data-mp="2sgma0w2pe2">
                  {t('cta.readMore')}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-183" data-mp="3hj1wpn8uenup" />
                </Link>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}